export default angular
  .module('app.holding.dashboard.metals')
  .constant('HoldingTroyRate', 31.1034)
  .name;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/metals/constants/troy-rate.js